"use strict";

import ReactDOM from 'react-dom';
import React from 'react';

import {  MarketBooksBrief  } from 'api/tradeAPICall';

import MoneyUtil from 'components/moneyUtil';
import ApplicationEvents from 'components/applicationEvents';
import {  PromiseDelay  } from 'generics/utils';

// LogStream.enable("BRIEFBOOKLOADERLOGGER")

export class BriefBookLoader extends React.Component  {
  constructor(props)  {
    super(props);

    this.onLoadOrdersList = () => this.loadOrdersList();
    this.tickerEventHandler = (...rest) =>  this.onTickerEvent(...rest);
    this.logger = LogStream("BRIEFBOOKLOADERLOGGER");
    this.pending = null;
    this.scheduled = false;
  }


  componentDidMount()  {
    ApplicationEvents.on("market.ordersUpdate", this.onLoadOrdersList);
    ApplicationEvents.on("market.notify.received", this.tickerEventHandler );
    this.loadOrdersList();
  }


  componentWillUnmount()  {
    ApplicationEvents.off("market.ordersUpdate", this.onLoadOrdersList);
    ApplicationEvents.off("market.notify.received", this.tickerEventHandler );
  }


  onTickerEvent( args, eventParams, details )  {
    const topic = details.decodedTopic;
    if ( !topic )                         return;
    if ( topic.eventType != "book" )      return;

    const {  market_name,  appid,  }  =  this.props;
    if ( market_name != topic.hashname )      return;
    if ( appid != topic.appId )               return;

    this.logger.info( `BriefBookLoader update due to ${details.topic}` );
    this.loadOrdersList();
  }


  processBriefBook( resp )  {
    const {  onUpdate,  }  =  this.props;
    if ( !onUpdate )
      return;

    const  {  BUY=[],  SELL=[],  depth={}  }  =  (resp||{});

    const totalSellDepth = (depth||{}).SELL || 0;
    const totalBuyDepth = (depth||{}).BUY || 0;

    const ordersSell = (SELL||[]).map( ([price, count])  =>  ({price:MoneyUtil.formatMoney(price), count}) );
    const ordersBuy  = ( BUY||[]).map( ([price, count])  =>  ({price:MoneyUtil.formatMoney(price), count}) );

    onUpdate({  totalSellDepth,  totalBuyDepth,  ordersSell,  ordersBuy  });
  }


  loadOrdersList() {
    const {  market_name,  appid,  }  =  this.props;

    if ( !market_name )  {
      this.logger.info( "skipped due to empty market_hash_name" );
      this.processBriefBook({});  // NOTE!
      return;
    }

    if (  this.pending )  {
      this.scheduled = true; // need reschedule
      return;
    }

    this.scheduled = false;
    this.pending = MarketBooksBrief(
          appid, market_name

      ).then((resp)  =>  {
        this.logger.info( "Result -> ", resp );
        this.processBriefBook(resp);

      }).catch((reason)  =>  {
        const message=`Failed to load market depth data:\n${reason.message}`;
        reason = Object.assign({}, reason, { message });
        this.logger.error( "Failed -> ", reason );
        this.processBriefBook({});

      });

    PromiseDelay(  1000, this.pending  ).then(  ()  =>  {
        this.pending = null;
        if ( this.scheduled )
          this.loadOrdersList();
      });
  }


  render()  {
    return(<span />); //  dummy
  }
}

